import type { ButtonConfig } from '../declare'
import * as Row from './row'
import { $consts } from 'src/plugins'

/**
 * 列表表单表格行按钮
 * @param props 
 * @returns 
 */
const RowButton = (props: { config: ButtonConfig }) => {
  const { BTN_TYPE } = props.config
  switch (BTN_TYPE) {
    // 自定义弹窗按钮
    case $consts['TABLE/BTN_TYPE_CUSTOM_PAGE']:
      return <Row.CustomModalBtn config={props.config} />
    // 删除按钮
    case $consts['TABLE/BTN_TYPE_DELETE']:
      return <Row.DeleteConfirmBtn config={props.config} />
    // 新增、编辑按钮、复制新增按钮
    case $consts['TABLE/BTN_TYPE_ADD']:
    case $consts['TABLE/BTN_TYPE_EDIT_PAGE']:
    case $consts['TABLE/BTN_TYPE_COPY']:
      return <Row.EditModalBtn config={props.config} />
    // 自定义事件按钮
    case $consts['TABLE/BTN_TYPE_CUSTOM_EVT']:
      return <Row.CustomEvtBtn config={props.config} />
    // 自定义按钮渲染
    case $consts['TABLE/BTN_TYPE_CUSTOM_BTN']:
      return <Row.CustomRenderBtn config={props.config} />
    // 查看按钮
    case $consts['TABLE/BTN_TYPE_VIEW']:
      return <Row.ViewModalBtn config={props.config} />
    // 列表弹窗按钮
    case $consts['TABLE/BTN_TYPE_LIST_PAGE']:
      return <Row.ListModalBtn config={props.config} />
    // 打印按钮
    case $consts['TABLE/BTN_TYPE_PRINT']:
      return <Row.PrintBtn config={props.config} />
    default:
      return <div />
  }
}

export default RowButton